<template>
  <v-container fluid class="auth-container py-0 px-0" :fill-height="$vuetify.breakpoint.mdAndUp">
    <v-container v-show="!loading" fluid class="auth-container-inner" :fill-height="$vuetify.breakpoint.mdAndUp" align-start justify-left>
      <v-container class="formulario_content">
        <v-flex xs12 class="formulario">
          <v-card flat>
            <v-card-title primary-title>
              <v-flex xs12>
                <v-img height="100px" width="250px" class="logo" :class="$vuetify.breakpoint.height > 800 ? 'mt-5' : ''" contain :src="require('@/assets/img/logo.jpg')" />
              </v-flex>
            </v-card-title>

            <v-card-text>
              <form id="talento_form" class="talento_form" @keyup.ctrl.83="executeValidators">
                <v-stepper v-model="step" class="steper">
                  <v-stepper-header class="align-items-center">
                    <v-progress-linear absolute :value="((step - 1) * 100) / 4" class="custom_progress"></v-progress-linear>
                    <v-stepper-step class="custom_step" :editable="!isDisableStepperStep1" :complete="step > 0" step="1"></v-stepper-step>
                    <v-spacer />
                    <v-stepper-step class="custom_step" :editable="!isDisableStepperStep1" :complete="step > 1" step="2"></v-stepper-step>
                    <v-spacer />
                    <v-stepper-step class="custom_step" :editable="!isDisableStepperStep1" :complete="step > 2" step="3"></v-stepper-step>
                    <v-spacer />
                    <v-stepper-step class="custom_step" :editable="!isDisableStepperStep1" :complete="step > 3" step="4"></v-stepper-step>
                    <v-spacer />
                    <v-stepper-step class="custom_step" :editable="!isDisableStepperStep1" :complete="step > 4" step="5"></v-stepper-step>
                  </v-stepper-header>
                  <v-stepper-items>
                    <v-stepper-content id="1" step="1" class="step">
                      <v-container fluid grid-list-md>
                        <v-layout row wrap justify-center>
                          <!-- Email -->
                          <v-flex xs12>
                            <div class="subheading px-0 pt-0 v-card__title text-center justify-center">{{ $t("view.talento.form.email.label") }}</div>
                            <v-text-field
                              v-model="$v.talento.email.$model"
                              :disabled="view.action.submit.busy || talento.clave != null"
                              :error-messages="getFirstErrorDescription($v.talento.email)"
                              :label="$t('view.talento.form.email.hint')"
                              prepend-inner-icon="mdi mdi-email"
                              maxlength="50"
                              class="f_email"
                              outlined
                              filled
                              single-line />
                          </v-flex>

                          <!-- CAPTCHA -->
                          <v-flex v-if="!token && showToken == false" xs12 text-center>
                            <v-layout row>
                              <v-flex xs12>
                                <div class="subheading px-0 pt-0 v-card__title text-center justify-center">{{ $t("view.talento.form.captcha.label") }}</div>
                              </v-flex>
                              <v-flex id="mc" xs12 class="captcha">
                                <h-captcha site-key="d6663ada-2d22-429a-a402-3f1c28f48ed4" @verified="onCaptchaVerified" @expired="onCaptchaExpired"></h-captcha>
                              </v-flex>
                            </v-layout>
                          </v-flex>

                          <!-- Token -->
                          <v-flex v-if="showToken" xs6>
                            <div class="subheading px-0 pt-0 v-card__title text-center justify-center">{{ $t("view.talento.form.token.label") }}</div>
                            <v-text-field
                              v-model="$v.token.$model"
                              :disabled="view.action.submit.busy"
                              :label="$t('view.talento.form.token.hint')"
                              :error-messages="getFirstErrorDescription($v.token)"
                              maxlength="5"
                              class="f_token"
                              outlined
                              filled
                              single-line />
                          </v-flex>

                          <v-flex xs12 class="mt-10">
                            <v-layout row wrap justify-center>
                              <v-flex shrink>
                                <v-btn v-if="showToken" elevation="0" :disabled="!resend" :loading="view.action.submit.busy" @click="sendValidationEmail()">
                                  {{ $t("view.talento.form.resend.label") }} {{ countdown || "" }}
                                </v-btn>
                                <v-btn elevation="0" color="primary" :disabled="isDisableButtonStep1" :loading="view.action.submit.busy" class="next" @click="change(2)">
                                  {{ $t("view.commons.next") }}
                                </v-btn>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-stepper-content>

                    <v-stepper-content id="2" step="2" class="step">
                      <v-container fluid grid-list-md>
                        <v-layout row wrap>
                          <!-- Image -->
                          <v-flex xs12 md4 class="pr-md-8">
                            <v-layout row>
                              <v-flex xs12>
                                <!-- eslint-disable-next-line vue/no-v-html -->
                                <div class="subheading px-0 pt-1 v-card__title text-center justify-center" style="line-height: 1.5rem" v-html="htmlLabelPhoto"></div>
                              </v-flex>

                              <v-flex justify-center-xs xs12 class="croppa_flex text-center justify-center">
                                <croppa
                                  v-model="croppa"
                                  :new-image-drawn="renderImage()"
                                  :zoom-speed="3"
                                  class="userdp ml-4"
                                  :width="$vuetify.breakpoint.mdAndUp ? 150 : 100"
                                  :height="$vuetify.breakpoint.mdAndUp ? 150 : 100"
                                  :placeholder="$t('view.commons.imgsel')"
                                  placeholder-color="#000"
                                  :placeholder-font-size="10"
                                  canvas-color="transparent"
                                  :show-loading="true"
                                  :loading-size="25"
                                  loading-color="#606060"
                                  initial-position="center"
                                  initial-size="cover"
                                  :show-remove-button="false"
                                  :prevent-white-space="true"
                                  accept="image/*"
                                  @move="renderImageChange"
                                  @zoom="renderImageChange" />
                              </v-flex>
                              <v-flex justify-center-xs xs12 class="croppa_flex text-center justify-center">
                                <v-btn
                                  v-if="talento.foto"
                                  fab
                                  outlined
                                  width="30"
                                  height="30"
                                  color="primary"
                                  class="btn_tippy deleteFoto"
                                  elevation="0"
                                  :title="$t('view.commons.imgrem')"
                                  @click="croppaRemove()">
                                  <em class="fas fa-times" />
                                </v-btn>
                              </v-flex>
                            </v-layout>
                          </v-flex>

                          <v-flex xs12 md8>
                            <v-layout row wrap>
                              <!-- Nombre -->
                              <v-flex xs12>
                                <div class="subheading px-0 pt-0 v-card__title text-center justify-center">{{ $t("view.talento.form.nombre.label") }}</div>
                                <v-text-field
                                  v-model="$v.talento.nombre.$model"
                                  :disabled="view.action.submit.busy"
                                  :error-messages="getFirstErrorDescription($v.talento.nombre)"
                                  :label="$t('view.talento.form.nombre.label')"
                                  prepend-inner-icon="mdi mdi-account"
                                  maxlength="50"
                                  class="f_nombre"
                                  outlined
                                  filled
                                  single-line />
                              </v-flex>

                              <!-- LinkedIn -->
                              <v-flex xs12>
                                <div class="subheading px-0 pt-0 v-card__title text-center justify-center">{{ $t("view.talento.form.linkedin.label") }}</div>
                                <v-text-field
                                  v-model="$v.talento.linkedin.$model"
                                  :disabled="view.action.submit.busy"
                                  :error-messages="getFirstErrorDescription($v.talento.linkedin)"
                                  :label="$t('view.talento.form.linkedin.hint')"
                                  prepend-inner-icon="fab fa-linkedin-in"
                                  maxlength="255"
                                  class="f_linkedin"
                                  outlined
                                  filled
                                  single-line />
                              </v-flex>

                              <!-- Perfiles -->
                              <v-flex xs12>
                                <div class="subheading px-0 pt-0 v-card__title text-center justify-center flex-column">
                                  <span>{{ $t("view.talento.form.perfiles.label") }}</span>
                                  <span class='small-text'>{{ $t("view.talento.form.perfiles.note") }}</span>
                                </div>
                                <v-autocomplete
                                  v-model.trim="$v.talento.perfiles.$model"
                                  :search-input.sync="view.elem.select.perfiles.search"
                                  :label="$t('view.talento.form.perfiles.hint')"
                                  :error-messages="getFirstErrorDescription($v.talento.perfiles)"
                                  :items="view.elem.select.perfiles.filteredList"
                                  :disabled="view.action.submit.busy"
                                  item-value="code"
                                  item-text="name"
                                  class="f_perfiles"
                                  return-object
                                  deletable-chips
                                  hide-selected
                                  clearable
                                  outlined
                                  filled
                                  multiple
                                  small-chips
                                  :no-data-text="$t('view.commons.nodata')"
                                  @input="view.elem.select.perfiles.search = ''" />
                              </v-flex>

                              <!-- Titulo universitario -->
                              <v-flex xs12>
                                <div class="subheading px-0 pt-0 v-card__title text-center justify-center">{{ $t("view.talento.form.titulouni.label") }}</div>
                                <v-text-field
                                  v-model="$v.talento.titulouni.$model"
                                  :disabled="view.action.submit.busy"
                                  :error-messages="getFirstErrorDescription($v.talento.titulouni)"
                                  :label="$t('view.talento.form.titulouni.label')"
                                  prepend-inner-icon="mdi-account-school"
                                  maxlength="255"
                                  class="f_titulouni"
                                  outlined
                                  filled
                                  single-line />
                              </v-flex>
                            </v-layout>
                          </v-flex>

                          <v-flex xs12 class="mt-3 step2">
                            <v-layout row wrap justify-center>
                              <v-flex shrink>
                                <v-btn elevation="0" :loading="view.action.submit.busy" @click="step = 1"> {{ $t("view.commons.prev") }} </v-btn>
                                <v-btn elevation="0" color="primary" :loading="view.action.submit.busy" class="next" @click="change(3)"> {{ $t("view.commons.next") }} </v-btn>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-stepper-content>

                    <v-stepper-content id="3" step="3" class="step">
                      <v-container fluid grid-list-md>
                        <v-layout row wrap>
                          <!-- Pais -->
                          <v-flex xs12>
                            <div class="subheading px-0 pt-0 v-card__title text-center justify-center">{{ $t("view.talento.form.pais.label") }}</div>
                            <v-autocomplete
                              v-model.trim="$v.talento.pais.$model"
                              :search-input.sync="view.elem.select.pais.search"
                              :label="$t('view.talento.form.pais.label')"
                              :error-messages="getFirstErrorDescription($v.talento.pais)"
                              :items="view.elem.select.pais.filteredList"
                              :disabled="view.action.submit.busy"
                              prepend-inner-icon="mdi mdi-earth"
                              item-value="code"
                              item-text="name"
                              class="f_pais"
                              return-object
                              hide-selected
                              clearable
                              outlined
                              filled
                              :no-data-text="$t('view.commons.nodata')"
                              @input="view.elem.select.pais.search = ''"
                              @change="loadSelectProvincia">
                              <template #selection="data"
                                ><v-icon small class="mx-2">fi fi-{{ data.item.codigo }}</v-icon
                                >{{ data.item.name }}
                              </template>
                              <template #item="data">
                                <v-list-item-icon dense>
                                  <v-icon small>fi fi-{{ data.item.codigo }}</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content dense>
                                  <v-list-item-title>{{ data.item.name }}</v-list-item-title>
                                </v-list-item-content>
                              </template>
                            </v-autocomplete>
                          </v-flex>

                          <!-- Provincia -->
                          <v-flex xs12>
                            <div class="subheading px-0 pt-0 v-card__title text-center justify-center">{{ $t("view.talento.form.provincia.label") }}</div>
                            <v-autocomplete
                              v-model.trim="$v.talento.provincia.$model"
                              :search-input.sync="view.elem.select.provincia.search"
                              :label="$t('view.talento.form.provincia.label')"
                              :error-messages="getFirstErrorDescription($v.talento.provincia)"
                              :items="view.elem.select.provincia.filteredList"
                              :disabled="view.action.submit.busy"
                              prepend-inner-icon="mdi mdi-map"
                              item-value="code"
                              item-text="name"
                              class="f_provincia"
                              hide-selected
                              clearable
                              outlined
                              filled
                              :no-data-text="$t('view.commons.nodata')"
                              @input="view.elem.select.provincia.search = ''"
                              @change="loadSelectLocalidad" />
                          </v-flex>

                          <!-- Localidad -->
                          <v-flex xs12>
                            <div class="subheading px-0 pt-0 v-card__title text-center justify-center">{{ $t("view.talento.form.localidad.label") }}</div>
                            <v-autocomplete
                              v-model.trim="$v.talento.localidad.$model"
                              :search-input.sync="view.elem.select.localidad.search"
                              :label="$t('view.talento.form.localidad.label')"
                              :error-messages="getFirstErrorDescription($v.talento.localidad)"
                              :items="view.elem.select.localidad.filteredList"
                              :disabled="view.action.submit.busy"
                              prepend-inner-icon="fas fa-map-marker-alt"
                              item-value="code"
                              item-text="name"
                              class="f_localidad"
                              hide-selected
                              clearable
                              outlined
                              filled
                              :no-data-text="$t('view.commons.nodata')"
                              @input="view.elem.select.localidad.search = ''" />
                          </v-flex>

                          <v-flex xs12 class="mt-3 step3">
                            <v-layout row wrap justify-center>
                              <v-flex shrink>
                                <v-btn elevation="0" :loading="view.action.submit.busy" @click="step = 2"> {{ $t("view.commons.prev") }} </v-btn>
                                <v-btn elevation="0" color="primary" :loading="view.action.submit.busy" class="next" @click="change(4)"> {{ $t("view.commons.next") }} </v-btn>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-stepper-content>

                    <v-stepper-content id="4" step="4" class="step">
                      <v-container fluid grid-list-md>
                        <v-layout row wrap>
                          <!-- Telefonos -->
                          <talento-telefonos
                            :key="refreshkey + '_telefonos'"
                            ref="telefonos"
                            class="f_telefonos"
                            :talento="talento"
                            :disabled="view.action.submit.busy"
                            :error-messages="getFirstErrorDescription($v.talento.telefonos)" />

                          <!-- Usuarios -->
                          <talento-usuarios
                            :key="refreshkey + '_usuarios'"
                            ref="usuarios"
                            class="f_usuarios"
                            :talento="talento"
                            :disabled="view.action.submit.busy"
                            :error-messages="getFirstErrorDescription($v.talento.usuarios)" />
                            
                          <!-- Idiomas -->
                          <talento-idiomas
                            :key="refreshkey + '_idiomas'"
                            ref="idiomas"
                            class="f_idiomas"
                            :talento="talento"
                            :disabled="view.action.submit.busy"
                            :error-messages="getFirstErrorDescription($v.talento.idiomas)" />

                          <v-flex xs12 class="mt-3 step4">
                            <v-layout row wrap justify-center>
                              <v-flex shrink>
                                <v-btn elevation="0" :loading="view.action.submit.busy" @click="step = 3"> {{ $t("view.commons.prev") }} </v-btn>
                                <v-btn elevation="0" color="primary" :loading="view.action.submit.busy" class="next" @click="change(5)"> {{ $t("view.commons.next") }} </v-btn>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-stepper-content>

                    <v-stepper-content id="5" step="5" class="step">
                      <v-container fluid grid-list-md>
                        <v-layout row wrap>
                          <!-- Observaciones -->
                          <v-flex xs12>
                            <v-label for="cuerpo">{{ $t("view.talento.form.observaciones.label") }}</v-label>
                          </v-flex>
                          <talento-observaciones :key="refreshkey + '_observaciones'" ref="observaciones" :talento="talento" @observaciones="observaciones" />

                          <!-- Rango Salarial -->
                          <v-flex xs12 class="mt-6 pb-0">
                            <v-label for="rangoSalarial">{{ $t("view.talento.form.rangoSalarial.label") }}</v-label>
                          </v-flex>
                          <v-flex xs12 class="mt-2" >                           
                            <v-text-field
                              v-model="$v.talento.rangoSalarial.$model"
                              :disabled="view.action.submit.busy"
                              :error-messages="getFirstErrorDescription($v.talento.rangoSalarial)"
                              :label="$t('view.talento.form.rangoSalarial.label')"
                              prepend-inner-icon="mdi mdi-currency-usd"
                              maxlength="80" 
                              outlined
                              filled 
                              single-line />
                          </v-flex>

                          <!-- Adjuntos -->
                          <v-flex xs12 class="pb-0">
                            <!-- eslint-disable-next-line vue/no-v-html -->
                            <v-label for="adjuntos" v-html="htmlLabelAdjuntos"></v-label>
                          </v-flex>
                          <v-flex xs12>
                            <talento-adjuntos :key="refreshkey + '_adjuntos'" ref="adjuntos" :talento="talento" :maxfilesize="maxfilesize" @adjuntos="adjuntos" />
                          </v-flex>

                          <!-- Adjuntos Video-->
                          <v-flex xs12 class="mt-4 pb-0">
                            <!-- eslint-disable-next-line vue/no-v-html -->
                            <v-label for="video" v-html="htmlLabelVideo"></v-label>
                          </v-flex>
                          <v-flex xs12 style="margin-bottom: 30px">
                            <talento-video :key="refreshkey + '_video'" ref="video" :talento="talento" :maxvideosize="maxvideosize" @video="video" />
                          </v-flex>

                          <v-flex xs12>
                            <v-layout row wrap justify-center>
                              <v-flex shrink>
                                <v-btn elevation="0" :loading="view.action.submit.busy" @click="step = 4"> {{ $t("view.commons.prev") }} </v-btn>
                                <v-btn elevation="0" color="primary" :loading="view.action.submit.busy" :disabled="isDisableButtonSubmit" class="next" @click="submit()">
                                  {{ view.elem.button.submit.title.current }}
                                </v-btn>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-stepper-content>
                  </v-stepper-items>
                </v-stepper>
              </form>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-container>
    </v-container>
    <v-snackbars :objects.sync="snackbar" :timeout="900000" app top right>
      <template #default="{ message }">
        <v-alert v-model="snackbar.show" :type="JSON.parse(message).color" class="my-0 py-0 px-0">
          <h3 class="text-h9 my-0 error_code">
            {{ JSON.parse(message).code }}
          </h3>
          <div>
            {{ JSON.parse(message).message }}
          </div>
        </v-alert>
      </template>
      <template #action="{ close }">
        <v-btn icon @click="close()">
          <v-icon>mdi mdi-close-circle</v-icon>
        </v-btn>
      </template>
    </v-snackbars>
    <v-slide-x-reverse-transition>
      <div v-if="loading" class="loading">
        <v-layout align-content-center text-center row>
          <v-flex xs12>
            <h2 class="text-h5 font-weight-bold message-title">{{ $t("view.talento.form.loading.label") }}</h2>
          </v-flex>
          <v-flex xs12>
            <p class="message-instruction">{{ $t("view.talento.form.loading.desc") }}</p>
          </v-flex>
          <v-flex xs12>
            <div v-if="view.action.submit.busy" class="sk-spinner sk-spinner-circle message-spinner">
              <div class="sk-circle1 sk-circle" />
              <div class="sk-circle2 sk-circle" />
              <div class="sk-circle3 sk-circle" />
              <div class="sk-circle4 sk-circle" />
              <div class="sk-circle5 sk-circle" />
              <div class="sk-circle6 sk-circle" />
              <div class="sk-circle7 sk-circle" />
              <div class="sk-circle8 sk-circle" />
              <div class="sk-circle9 sk-circle" />
              <div class="sk-circle10 sk-circle" />
              <div class="sk-circle11 sk-circle" />
              <div class="sk-circle12 sk-circle" />
            </div>
            <div v-if="!view.action.submit.busy" class="swal2-icon swal2-success swal2-animate-success-icon" style="display: flex">
              <div class="swal2-success-circular-line-left" style="background-color: rgb(255, 255, 255)"></div>
              <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>
              <div class="swal2-success-ring"></div>
              <div class="swal2-success-fix" style="background-color: rgb(255, 255, 255)"></div>
              <div class="swal2-success-circular-line-right" style="background-color: rgb(255, 255, 255)"></div>
            </div>
          </v-flex>
        </v-layout>
      </div>
    </v-slide-x-reverse-transition>
    <footer>{{ talento.origencv }} {{ $t("view.commons.copyright") }}</footer>
  </v-container>
</template>
<script>
import talentoAPI from "@/services/talento"; /** *******************************/
import ParametrosAPI from "@/services/generales/parametros"; /** *******************************/
import talentoStates from "@/views/talento/talento-state"; /** *******************************/
import TalentoTelefonos from "@/views/talento/TalentoTelefonos"; /** *******************************/
import TalentoUsuarios from "@/views/talento/TalentoUsuarios"; /** *******************************/
import TalentoIdiomas from "@/views/talento/TalentoIdiomas"; /** *******************************/
import TalentoObservaciones from "@/views/talento/TalentoObservaciones"; /** *******************************/
import TalentoAdjuntos from "@/views/talento/TalentoAdjuntos"; /** *******************************/
import TalentoVideo from "@/views/talento/TalentoVideo.vue"; /** *******************************/
import { EventBus } from "@/events/event-bus";
import * as events from "@/constants/event-names";
import { required, requiredIf, email } from "vuelidate/lib/validators";
import { allValidatorMethods } from "@/helpers/vuelidate";
import { handleResponse } from "@/helpers/http-response-handler";
import { submit } from "@/constants/buttons";
import { setToday } from "@/helpers/date-methods";
import { modelIsModified } from "@/helpers/vue-mc";
import { registroTalentoSwal, tokenTalentoSwal } from "@/constants/sweet-alerts";
import tippy from "tippy.js";
import VSnackbars from "v-snackbars";

const action = { submit: { busy: false } };

const select = {
  pais: {
    completeList: []
    , filteredList: []
    , disabled: false
    , search: ""
  }
  , provincia: {
    completeList: []
    , filteredList: []
    , disabled: false
    , search: ""
  }
  , localidad: {
    completeList: []
    , filteredList: []
    , disabled: false
    , search: ""
  }
  , perfiles: {
    completeList: []
    , filteredList: []
    , disabled: false
    , search: ""
  }
};

export default {
  name: "TalentoModule"
  , components: {
    TalentoTelefonos
    , TalentoUsuarios
    , TalentoIdiomas
    , TalentoObservaciones
    , TalentoAdjuntos
    , TalentoVideo
    , VSnackbars
  }
  , data() {
    return {
      talento: undefined
      , timer: undefined
      , init: true
      , step: 1
      , captcha: false
      , token: null
      , showToken: false
      , resend: true
      , valid: false
      , refreshkey: 0
      , maxfilesize: 0
      , maxvideosize: 0
      , countdown: 0
      , oldemail: ""
      , snackbar: []
      , loading: false
      , form: new Object()
      , view: {
        title: this.$t("view.talento.title")
        , action
        , elem: {
          button: {
            submit
            , removeImg: { visible: false }
          }
          , select
        }
      }
      , croppa: {}
      , croppainput: true
    };
  }
  , head: {
    title: function () {
      return {
        inner: this.view.title
        , separator: "|"
        , complement: this.$t("view.commons.system")
      };
    }
  }
  , computed: {
    isDisableButtonStep1() {
      return !this.token && !this.showToken && (this.hasErrors(this.$v.talento) || this.view.action.submit.busy || !modelIsModified(this.talento) || !this.captcha);
    }
    , isDisableStepperStep1() {
      return !this.token || this.showToken;
    }
    , isDisableButtonSubmit() {
      return this.hasErrors(this.$v.talento) || this.view.action.submit.busy || !modelIsModified(this.talento) || !this.captcha;
    }
    , htmlLabelPhoto() {
      return this.$t("view.talento.form.avatar.label");
    }
    , htmlLabelAdjuntos(){
      return this.$t("view.talento.form.adjuntos.label");
    }
    , htmlLabelVideo(){
      return this.$t("view.talento.form.video.label");
    }
  }
  , created() {
    this.captcha = false;
    this.form = new talentoStates(this);
    this.form.$setState("initial");
    this.getMaxFileSize();
    this.getMaxVideoSize();

    setTimeout(() => {
      let steps = document.querySelectorAll(".custom_step .v-stepper__step__step");
      steps.forEach((elem) => {
        elem.innerHTML = "<i aria-hidden=\"true\" class=\"v-icon notranslate fas fa-user-tie theme--light\"></i>";
      });
    }, 60);

    EventBus.$on(events.SHOW_TOASTER_MESSAGE, (type, code, message, timeout = 6000) => {
      this.showToaster(type, code, message, timeout);
    });
  }
  , updated() {
    let steps = document.querySelectorAll(".custom_step .v-stepper__step__step");
    steps.forEach((elem) => {
      elem.innerHTML = "<i aria-hidden=\"true\" class=\"v-icon notranslate fas fa-user-tie theme--light\"></i>";
    });
    this.$nextTick(function () {
      tippy(".btn_tippy", { arrow: true, arrowType: "round", animation: "scale" });
    });
  }
  , methods: {
    ...allValidatorMethods
    , async submit() {
      try {
        if (!this.isAllValid(this.$v)) {
          EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", this.$t("errors.validof"));
          this.changeToStep();
          return false;
        }

        if (!this.$refs.adjuntos.validateFilesBeforeSubmit()) {
          return false;
        }

        if (!modelIsModified(this.talento)) {
          EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "info", "VL0000", this.$t("errors.nochanges"));
          return false;
        }

        if ((await this.$swal(registroTalentoSwal)).value) {
          this.view.action.submit.busy = true;
          this.loading = true;
          await this.$refs.adjuntos.$refs.pond.processFiles();
          await this.$refs.video.$refs.pond_video.processFiles();
          const respuesta = await this.form.$state.submit(this.talento);
          if (handleResponse(respuesta, this.$t("view.talento.errors"))) {
            setTimeout(() => location.reload(), 6000);
          }
        }
      } catch (error) {
        handleResponse(error, this.$t("view.talento.errors"));
        this.view.action.submit.busy = false;
      }
    }
    , async change(step) {
      if (!this.valid && this.step == 1) {
        if (!this.isAllValid(this.$v)) {
          EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", this.$t("errors.validof"));
          return false;
        }

        if (!(await this.validateEmail())) return false;
      }
      this.step = step;
    }
    , async validateEmail() {
      if (!this.showToken && !this.token) {
        if (this.oldemail == this.talento.email) {
          await this.$swal(tokenTalentoSwal);
          this.oldemail = this.talento.email;
          return false;
        }

        await this.sendValidationEmail();
        this.oldemail = this.talento.email;
        this.showToken = true;
        this.token = null;
        this.form.$state.resetValidators();
        return false;
      } else if (this.showToken && this.token != "") {
        const response = await talentoAPI.token(this.talento.email, this.token);
        const { data: { results: { valid, exist } } } = response;
        if (!valid) {
          EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", this.$t("view.talento.errors.token.text"));
          this.token = null;
          this.resend = true;
          clearInterval(this.timer);
          this.countdown = 0;
          return false;
        }

        if (exist) {
          await this.load(response.data.results.talento);
        }
        this.form.$state.resetValidators();
        this.showToken = false;
        this.valid = true;
      }
      return true;
    }
    , async sendValidationEmail() {
      await talentoAPI.exist(this.talento.email, this.talento.nombre);
      await this.$swal(tokenTalentoSwal);
      this.resend = false;

      clearInterval(this.timer);
      this.countdown = 30;
      this.timer = setInterval(() => {
        if (this.countdown > 0) this.countdown--;
        if (this.countdown <= 0 && this.showToken && !this.resend) {
          this.resend = true;
          clearInterval(this.timer);
        }
      }, 1000);
    }
    , changeToStep() {
      const errf = Object.keys(this.$v.talento).filter((fieldName) => this.$v.talento[fieldName].$invalid);
      errf.forEach((element, index) => {
        errf[index] = ".f_" + element;
      });
      const classes = errf.join();
      const elems = document.querySelectorAll(classes);
      if (elems && elems.length > 0) {
        const steps = elems[0].closest(".step");
        if (steps) this.step = Number(steps.getAttribute("id"));
      }
    }
    , async load(talento) {
      await this.form.$state.loadImage(talento.foto && talento.foto != "" ? talento.foto : "/static/img/user_thumbnail.jpg");
      if (talento.pais) {
        await this.form.$state.loadSelectProvincia(this.view.elem.select.pais.filteredList.find((value) => value.code == Number(talento.pais)));
        if (talento.provincia) await this.form.$state.loadSelectLocalidad(talento.provincia);
      }
      this.form.$setState("editing", talento);
    }
    , async loadSelectProvincia() {
      this.talento.provincia = null;
      this.talento.localidad = null;
      if (this.form.$state && this.talento.pais) await this.form.$state.loadSelectProvincia();
    }
    , async loadSelectLocalidad() {
      this.talento.localidad = null;
      if (this.form.$state && this.talento.provincia) {
        await this.form.$state.loadSelectLocalidad();
      }
    }
    , async clear() {
      await this.form.$state.askForClear();
      setTimeout(() => document.body.click(), 300);
    }
    , executeValidators() {
      if (!this.isAllValid(this.$v)) {
        EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", this.$t("errors.validof"));
      }
    }
    , renderImage() {
      if (this.croppainput && this.croppa && this.croppa.hasImage) {
        this.talento.foto = this.croppa.generateDataUrl("image/jpeg", 0.5);
        this.croppainput = this.talento.foto.length == 0;
      }
    }
    , renderImageChange() {
      if (this.croppa && this.croppa.hasImage) {
        this.talento.foto = this.croppa.generateDataUrl("image/jpeg", 0.5);
      }
    }
    , croppaRemove() {
      this.talento.foto = "";
      this.view.elem.button.removeImg.visible = false;
      this.croppa.remove();
      this.croppainput = true;
      setTimeout(() => document.body.click(), 100);
    }
    , async observaciones(observaciones) {
      this.talento.observacionesgen = observaciones;
    }
    , async adjuntos(adjuntos) {
      this.talento.adjuntos = adjuntos;
    }
    , async video(video) {
      this.talento.video = video;
    }
    , async getMaxFileSize() {
      this.maxfilesize = Number(this.$cookie.get("maxfilesize"));
      if (!this.maxfilesize) {
        const response = await ParametrosAPI.get({ clave: 1 });
        this.maxfilesize = response == null || response.data.results.parametros.maxFileSizeNST == null ? 0 : response.data.results.parametros.maxFileSizeNST;
        this.$cookie.set("maxfilesize", this.maxfilesize, 1);
      }
    }
    , async getMaxVideoSize() {
      this.maxvideosize = Number(this.$cookie.get("maxvideosize"));
      if (!this.maxvideosize) {
        const response = await ParametrosAPI.get({ clave: 1 });
        this.maxvideosize = response == null || response.data.results.parametros.maxVideoSize == null ? 0 : response.data.results.parametros.maxVideoSize;
        this.$cookie.set("maxvideosize", this.maxvideosize, 1);
      }
    }
    , showToaster(type, code, message, timeout) {
      try {
        if (type.toLowerCase() === "success") {
          message = message || this.$t("errors.success");
        } else if (type.toLowerCase() === "error") {
          message = message || this.$t("errors.error");
        } else if (type.toLowerCase() == "warning") {
          message = message || this.$t("errors.warning");
        }
      } catch (error) {
        return false;
      }
      const obj = {
        message
        , code
        , color: type
        , timeout
      };
      obj.message = JSON.stringify(obj);
      this.snackbar.push(obj);
    }
    , onCaptchaVerified() {
      this.captcha = true;
    }
    , onCaptchaExpired() {
      this.captcha = false;
    }
    , setToday
  }
  , validations: {
    talento: {
      nombre: {
        required: requiredIf(function () {
          return this.step > 1;
        })
      }
      , email: {
        required
        , email: function (value) {
          if (this.talento.clave != null) {
            return true;
          } else {
            return email(value);
          }
        }
      }
      , linkedin: {}
      , perfiles: {
        required: requiredIf(function () {
          return this.step > 1;
        })
      }
      , pais: {
        required: requiredIf(function () {
          return this.step > 1;
        })
      }
      , provincia: {
        required: requiredIf(function () {
          return this.step > 1;
        })
      }
      , localidad: { }
      , telefonos: {
        required: requiredIf(function () {
          return this.step > 1;
        })
      }
      , usuarios: {}
      , idiomas: {
        required: requiredIf(function () {
          return this.step > 1;
        })
      }
      , adjuntos: {}
      , video: {}
      , observacionesgen: {}
      , rangoSalarial: {}
      , foto: {}
      , titulouni: {}
    }
    , token: {
      required: requiredIf(function () {
        return this.showToken;
      })
    }
  }
};
</script>

<style scoped>
.formulario_content {
  max-width: 700px;
  min-height: 600px;
  margin-left: 0;
}

.formulario .v-card {
  background: none !important;
}

.talento_form .croppa_flex {
  display: flex;
  align-items: center;
  align-self: center;
  justify-content: start;
}

.talento_form .croppa_flex .button {
  padding-top: 10px !important;
  padding-bottom: 30px !important;
}

.talento_form .userdp {
  height: 150px;
  width: 150px;
  border-radius: 50%;
  overflow: hidden;
}

.talento_form .v-chip.v-size--small {
  height: auto !important;
  min-height: 24px !important;
  white-space: break-spaces !important;
}

.steper {
  background: inherit !important;
  box-shadow: none !important;
  border: none;
}

.subheading {
  word-break: normal;
}

footer {
  position: fixed;
  bottom: 15px;
  right: 20px;
  color: white;
}

/* Media Query for small devices */
@media (min-width: 1300px) {
  .auth-container:before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 0;
    display: block;
    width: 100%;
    background-image: url("~@/assets/img/background.jpg");
    background-size: 100% 100%;
    background-position: center;
    height: 100%;
  }
  .auth-container-inner {
    background: linear-gradient(90deg, rgba(255, 255, 255, 0.863) 50%, rgba(255, 255, 255, 0.171) 80%, rgba(255, 255, 255, 0) 90%) !important;
    z-index: 1;
  }
}

@media (min-width: 1903px) {
  .auth-container-inner {
    background: linear-gradient(90deg, rgba(255, 255, 255, 0.863) 40%, rgba(255, 255, 255, 0.171) 70%, rgba(255, 255, 255, 0) 80%) !important;
    z-index: 1;
  }
}

@media only screen and (max-width: 968px) {
  .auth-container-inner {
    padding: 0;
  }

  .logo {
    margin-top: 10px;
    margin-left: auto;
    margin-right: auto;
    height: 40px !important;
    width: 150px !important;
  }

  .subheading {
    padding-left: 0 !important;
    text-align: center;
  }

  footer {
    position: absolute;
  }

  .formulario_content {
    min-height: none;
  }
}
</style>

<style>
.talento_form {
  padding-top: 20px;
}

a,
a:link,
a:visited,
a:hover,
a:active {
  text-decoration: none !important;
  color: var(--v-primary-base) !important;
}

.v-text-field--filled.v-input--dense.v-text-field--outlined.v-text-field--filled > .v-input__control > .v-input__slot,
.v-text-field--filled.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot,
.v-text-field--outlined.v-input--dense.v-text-field--outlined.v-text-field--filled > .v-input__control > .v-input__slot,
.v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 48px !important;
}
.v-text-field--outlined.v-input--dense .v-label {
  top: 15px !important;
}
.v-text-field--outlined.v-input--dense .v-label--active {
  transform: translateY(-23px) scale(0.75) !important;
}
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-inner {
  margin-top: 12px !important;
}

.theme--light.v-chip:not(.v-chip--active) {
  background: #c6c3c3 !important;
}

.loading {
  position: absolute;
  width: 100%;
  height: 100%;
  background: #ffffffe5;
  z-index: 1;
  top: 0;
  padding: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading .swal2-success-circular-line-left {
  background-color: transparent !important;
}
.loading .swal2-success-fix {
  background-color: transparent !important;
}
.loading .swal2-success-circular-line-right {
  background-color: transparent !important;
}

.small-text {
  font-size: 11px;
}

.talento_form .v-stepper__header {
  box-shadow: none !important;
  height: auto !important;
  align-items: center !important;
}

.talento_form .v-stepper__header .v-stepper__step {
  padding: 15px !important;
  border-radius: 80px !important;
  width: 70px !important;
  height: 70px !important;
  z-index: 1 !important;
}

.talento_form .v-stepper__step__step {
  width: 40px !important;
  height: 40px !important;
  margin: 0 !important;
}

.talento_form .v-stepper__header .custom_progress {
  height: 6px !important;
  width: 95% !important;
  margin-left: 15px !important;
}

.talento_form .v-stepper__step__step .v-icon.v-icon {
  font-size: 1rem !important;
}

.theme--light.v-stepper .v-stepper__step:not(.v-stepper__step--active):not(.v-stepper__step--complete):not(.v-stepper__step--error) .v-stepper__step__step {
  background: #999695 !important;
}

.talento_form .step {
  padding: 0 !important;
}

.talento_form .v-slide-group__content {
  justify-content: center;
}

.talento_form .v-text-field__details {
  margin-bottom: 0 !important;
}

.talento_form .step2 {
  margin-top: 54px !important;
}

.talento_form .step3 {
  margin-top: 10px !important;
}

.talento_form .step4 {
  margin-top: 10px !important;
}

@media only screen and (max-width: 968px) {
  .talento_form {
    padding-top: 0 !important;
  }

  .talento_form .subheading {
    padding-top: 0px !important;
    padding-bottom: 10px !important;
  }

  .talento_form .v-input__slot {
    margin-bottom: 3px !important;
  }

  .talento_form .step2 {
    margin-top: 100px !important;
  }

  .talento_form .step3 {
    margin-top: 10px !important;
  }

  .talento_form .step4 {
    margin-top: 10px !important;
  }

  .talento_form .cita .desc {
    padding-bottom: 20px;
  }

  .talento_form .v-card__title {
    font-size: 1rem !important;
  }

  .talento_form .v-stepper__header .v-stepper__step {
    padding: 15px !important;
    border-radius: 80px !important;
    width: 60px !important;
    height: 60px !important;
    z-index: 1 !important;
  }

  .talento_form .v-stepper__step__step {
    width: 30px !important;
    height: 30px !important;
    margin: 0 !important;
  }

  .talento_form .v-stepper__header .custom_progress {
    height: 6px !important;
    width: 85% !important;
    margin-left: 15px !important;
  }

  .talento_form .v-stepper__step__step .v-icon.v-icon {
    font-size: 0.8rem !important;
  }

  .formulario .v-card__text {
    padding: 0 !important;
  }

  .v-alert {
    font-size: 14px !important;
  }
  .error_code {
    display: none;
  }
  .v-alert .v-icon.mdi-alert {
    margin-top: 8px;
  }

  .talento_form .croppa_flex {
    display: flex;
    align-items: center;
    align-self: center;
    justify-content: center;
    padding-top: 0px !important;
    padding-bottom: 10px !important;
  }

  .talento_form .userdp {
    height: 110px;
    width: 110px;
    border-radius: 50%;
    overflow: hidden;
  }
}

@media only screen and (max-width: 1300px) {
  .formulario_content {
    max-width: 90% !important;
    margin-left: auto !important;
  }
}

@media only screen and (min-width: 900px) {
  .talento_form .v-btn:not(.v-btn--round).v-size--default {
    padding: 0 46px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/talento/Talento.vue